module.exports = __webpack_public_path__ + "media/images/favicons/favicon-3ef39ebb07486beaa27bcd8a262e87a5.ico";